<template>
  <div v-if="is_load" class="membership_home_width">
    <div>
      <p class="headline mt-7 mb-0">멤버십 설정 현황</p>

      <div class="d-flex">
        <v-card width="242" outlined class="mt-3 pt-0 d-flex mr-3">
          <v-card-text class="pa-0">
            <div class="float-left" style="width: 100%;">
              <p
                style="font-size: 1rem;"
                class="mb-3 mt-3 ml-5 mr-5 pt-1 black--text"
              >
                현재 사용중인 멤버십 회원
              </p>
              <p
                class="headline font-weight-light font-weight-bold mb-3 mt-3 ml-5 mr-5 pt-1 black--text text-start"
                style="font-size: 1rem;"
              >
                {{ membership_user_count | comma }} 명
              </p>
            </div>
          </v-card-text>
        </v-card>

        <v-card
          v-if="membership_product_count <= 0"
          width="620"
          outlined
          class="mt-3 pt-0 d-flex"
        >
          <v-card-text class="pa-0">
            <div class="float-left">
              <p
                style="font-size: 1rem; color:black; padding-top:2px; color:#2196f3;"
                class="mb-0 mt-5 ml-7"
              >
                현재 멤버십 설정이 되어 있지 않습니다.
              </p>
              <p
                style="font-size: 1rem; color:black; padding-top:2px;"
                class="mb-5 mt-1 ml-7"
              >
                우리 쇼핑몰만의 멤버십을 회원에게 제공해보세요.
              </p>
            </div>
            <div class="mt-6 mr-7">
              <v-btn
                color="primary"
                hide-details
                style="float:right;"
                depressed
                large
                @click="moveMembershipManagePage()"
                >설정/관리</v-btn
              >
            </div>
          </v-card-text>
        </v-card>

        <v-card v-else width="620" outlined class="mt-3 pt-0 d-flex">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p
                style="font-size: 1rem; color:black; padding-top:2px; color:#2196f3;"
                class="mb-0 mt-5 ml-7"
              >
                현재 총 {{ membership_product_count }}개 상품에 멤버십을
                설정중입니다.
              </p>
              <p
                style="font-size: 1rem; color:black; padding-top:2px;"
                class="mb-5 mt-1 ml-7"
              >
                '설정/관리' 버튼을 클릭하시면 해당 목록으로 연결됩니다.
              </p>
            </div>
            <div class="mt-6 mr-7">
              <v-btn
                color="primary"
                hide-details
                style="float:right;"
                depressed
                large
                :disabled="settingButtonDisabled"
                @click="moveMembershipManagePage()"
                >설정/관리</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div class="mt-3 d-inline-block">
      <p class="headline mt-7 mb-0">오늘의 멤버십 현황</p>
      <DataViewCard title="멤버십 가입 회원" :display_data="today.join_count" />
      <DataViewCard
        title="멤버십 가입 주문"
        :display_data="today.order_count"
      />
      <DataViewCard
        title="멤버십 가입 상품 매출"
        :display_data="today.sales_amount"
      />
    </div>

    <div class="mt-3 d-inline-block">
      <p class="headline mt-7 mb-0">최근 1달 멤버십 현황</p>
      <DataViewCard title="멤버십 가입 회원" :display_data="month.join_count" />
      <DataViewCard
        title="멤버십 가입 주문"
        :display_data="month.order_count"
      />
      <DataViewCard
        title="멤버십 가입 상품 매출"
        :display_data="month.sales_amount"
      />
    </div>

    <div class="mt-3 d-inline-block">
      <p class="headline mt-7 mb-0">누적 멤버십 현황</p>
      <DataViewCard title="멤버십 가입 회원" :display_data="total.join_count" />
      <DataViewCard
        title="멤버십 가입 주문"
        :display_data="total.order_count"
      />
      <DataViewCard
        title="멤버십 가입 상품 매출"
        :display_data="total.sales_amount"
      />
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/membership/filters.js";

export default {
  data: () => {
    return {
      membership_product_count: 0,
      membership_user_count: 0,
      today: {
        join_count: 0,
        order_count: 0,
        sales_amount: 0,
      },
      month: {
        join_count: 20,
        order_count: 120,
        sales_amount: 43320,
      },
      total: {
        join_count: 281062,
        order_count: 506647,
        sales_amount: 20218106310,
      },
      total_use_member_count: 0,
      is_load: false,
      settingButtonDisabled: false,
      payment_info: {
        number_of_members: 0,
      },
    };
  },
  methods: {
    getMembershipUser: async function() {
      let result = [];
      try {
        result = await M.api(M.entry("/get/membership/usage"));
      } catch (e) {
        //console.log(e);
      }
      this.membership_user_count = 177995 + result.number_of_members;
    },
    getMembershipProduct: async function() {
      let result = [];
      try {
        result = await M.api(M.entry("/get/membership/products"));
      } catch (e) {
        //console.log(e);
      }

      this.membership_product_count = result.length;
    },
    //오늘의 멤버십 현황
    getMembershipTodayStatus: async function() {
      let toDay = new Date();
      let setParams = {
        sales_from: M.yyyymmdd(toDay),
        sales_to: M.yyyymmdd(toDay),
      };
      try {
        let result = await M.api(M.entry("/get/membership/sales"), setParams);
        //console.log("today", result);
        this.today = result;
      } catch (e) {
        //console.log(e);
      }
    },
    //최근 1달 멤버십 현황
    getMembershipMonthStatus: async function() {
      let toDay = new Date();
      let befor1Month = new Date();
      befor1Month.setMonth(befor1Month.getMonth() - 1);
      if (befor1Month.toISOString().slice(0, 10) < '2024-08-20') {
        befor1Month = new Date('2024-08-20');
      }

      const setParams = {
        sales_from: M.yyyymmdd(befor1Month),
        sales_to: M.yyyymmdd(toDay),
      };

      try {
        const result = await M.api(M.entry("/get/membership/sales"), setParams);
        //console.log("month", result);
        this.month = result;
      } catch (e) {
        //console.log(e);
      }
    },
    //누적 멤버십 현황
    getMembershipTotalStatus: async function() {
      const toDay = new Date();
      const setParams = {
        sales_from: "2024-08-20",
        sales_to: M.yyyymmdd(toDay),
      };

      try {
        const result = await M.api(M.entry("/get/membership/sales"), setParams);
        //console.log("total", result);

        this.total = {
          join_count: 342863 + result.join_count,
          order_count: 506647 + result.order_count,
          sales_amount: 20218106310 + result.sales_amount,
        };
        //this.total_use_member_count = result.join_count - result.canceled_count;
      } catch (e) {
        //console.log(e);
      }
    },
    moveMembershipManagePage: async function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/membershipManage`,
      });
    },
  },
  mixins: [CommonMixin],
  filters: Filters,
  components: {
    DataViewCard: () => import("@/components/membership/home/DataViewCard.vue"),
  },
  created: async function() {
    await this.getMembershipTodayStatus();
    await this.getMembershipMonthStatus();
    await this.getMembershipTotalStatus();
    await this.getMembershipProduct();
    await this.getMembershipUser();

    this.is_load = true;
    this.$parent.progressHide();
  },
};
</script>
